
import React, {useState } from "react";
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from "../components/Header";
import EmployeeFormContainer from '../components/EmployeeRegistration/EmployeeFormContainer';
import EmployeeList from '../components/empDetails/EmployeeList';
import AddAttendance from '../components/attendance/addAttendanceExcel';
import SalaryProcess from '../components/SalaryProcess/salaryProcess';
import Allowance from '../components/AllowanceDeductionDetails/allowance';
import Deduction from '../components/AllowanceDeductionDetails/Deduction';
import Department from "../components/AllowanceDeductionDetails/Department";
import Section from "../components/AllowanceDeductionDetails/Section";
import PTHeader from "../components/AllowanceDeductionDetails/PTHeader";
import SalaryReportsPage from '../components/payslipDetails/SalaryReportsPage';
import EmployeeBulkInsert from '../components/empDetails/EmployeeInsertExcel';
import EmployeeListWithoutLeave from '../components/Leaves/employeeListWithoutLeave';
import LeaveDetails from '../components/Leaves/LeaveDetails';
import BalanceLeaves from '../components/Leaves/balanceLeaves';
import ProtectedRoute from '../components/ProtectedRoute';
import EmployeeRole from "../components/roleallocation/EmployeeRole";
import ExistingUserRoles from '../components/roleallocation/ExistingUserRoles';

import SalarySlipForEmployee from "../components/PerEmployeeData/SalarySlipForEmployee"; 
import EmployeeLeaveDetails from "../components/PerEmployeeData/LeaveDetails"
import Profile from "../components/PerEmployeeData/Profile";
import ApplyLeave from "../components/PerEmployeeData/ApplyLeave";
import AppliedLeaveList from "../components/PerEmployeeData/AppliedLeaveList";
import LeaveList from "../components/Leaves/LeaveApplicationList"; 
import UploadDocument from "../components/PerEmployeeData/UploadDocument";

import UploadedDocuments from "../components/PerEmployeeData/UploadedDocuments";

import Form16View from "../components/Form16/Form16View";

const EmployeeDetails = () => {

  
  return (
    <div className="d-flex vh-100 bg-light">
      {/* FIX: make the Sidebar a real fixed-size flex item */}
      <div style={{ flex: '0 0 250px', minWidth: 250, maxWidth: 250, overflowY: 'auto' }}>
        <Sidebar />
        
      </div>
       <div style={{ flex: '1 1 auto', minWidth: 0, overflow: 'hidden', overflowY: 'auto' }}>
        {/* Header flush at top */}
        <Header />
        
      {/* FIX: allow main content to shrink and scroll; prevents pushing sidebar */}
      <div style={{ flex: '1 1 auto', padding: '20px', minWidth: 0, overflow: 'hidden' , overflowY: 'auto'}}>
        
        <Routes>
          
          <Route path="list" element={<EmployeeList />} />
          <Route path="edit/:id" element={<EmployeeFormContainer />} />
          <Route 
          path="addrole" 
          element={
            <ProtectedRoute formName="EmployeeRole" action="view">
              <EmployeeRole />
            </ProtectedRoute>
          } 
        />

        {/* <Route path="employee/existing-roles" element={<ExistingUserRoles />} /> */}

        
        <Route 
          path="existing-roles"
          element={
            <ProtectedRoute formName="ExistingUserRoles" action="view">
              <ExistingUserRoles />
            </ProtectedRoute>
          }
        />

          {/* <Route path="attendance/add-excel" element={<AddAttendance />} /> */}
          <Route 
          path="attendance/add-excel" 
          element={
            <ProtectedRoute formName="AddAttendanceExcel" action="view">
              <AddAttendance />
            </ProtectedRoute>
          } 
        />
          {/* <Route path="salary/process" element={<SalaryProcess />} /> */}
          <Route 
          path="salary/process" 
          element={
            <ProtectedRoute formName="SalaryProcess" action="view">
              <SalaryProcess />
            </ProtectedRoute>
          } 
        />
          {/* <Route path="allowances" element={<Allowance />} /> */}
          
           <Route
              path="allowances"
              element={
                <ProtectedRoute formName="AllowanceMaster" action="view">
                  <Allowance />
                </ProtectedRoute>
              }
            />
          <Route path="deductions" element={<Deduction />} />
          <Route path="department" element={<Department />} />
          <Route path="section" element={<Section />} />
          <Route path="ptheader" element={<PTHeader />}/>

          {/* <Route path="salary-reports" element={<SalaryReportsPage />} /> */}
          
          <Route
            path="salary-reports"
            element={
              <ProtectedRoute formName="SalaryReportsPage" action="view">
                <SalaryReportsPage />
              </ProtectedRoute>
            }
          />

          {/* <Route path="bulkinsert" element={<EmployeeBulkInsert />} /> */}
          <Route
            path="bulkinsert"
            element={
              <ProtectedRoute formName="AddEmployeeExcel" action="view">
                <EmployeeBulkInsert />
              </ProtectedRoute>
            }
          />

          <Route path="leaves" element={<EmployeeListWithoutLeave />} />
          <Route path="leaves/leave-list" element={<LeaveDetails />} />
          <Route path="leaves/balance-leaves"element={<BalanceLeaves/>} />
          
          <Route path="my-payslip" element={< SalarySlipForEmployee/>} />
          <Route path="my-leaves" element={< EmployeeLeaveDetails/>} />
          <Route path="profile" element={< Profile/>} />
          <Route path="apply-leave" element={< ApplyLeave/>} />
          <Route path="apply-leave/appliedleavelist" element={< AppliedLeaveList/>} />

          <Route path="leaveapplicationlist" element={<LeaveList />}/>

          <Route path="upload-documents" element={<UploadDocument />}/>
          <Route path="upload-documents/uploaded-document" element={<UploadedDocuments/>} />

          <Route path="from16" element={<Form16View/>} />


        </Routes>
      </div>
     </div>
     </div>
  );
};

export default EmployeeDetails;






// import React from 'react';
// import { Routes, Route } from 'react-router-dom';
// import Sidebar from '../components/Sidebar';
// import EmployeeFormContainer from '../components/EmployeeRegistration/EmployeeFormContainer';
// import EmployeeList from '../components/empDetails/EmployeeList';
// import AddAttendance from '../components/attendance/addAttendanceExcel';
// import SalaryProcess from '../components/SalaryProcess/salaryProcess';
// import Allowance from '../components/AllowanceDeductionDetails/allowance';
// import Deduction from '../components/AllowanceDeductionDetails/Deduction';
// // import SalaryRegister from '../components/payslipDetails/SalaryReport';
// import SalaryReportsPage from '../components/payslipDetails/SalaryReportsPage';
// import EmployeeBulkInsert from '../components/empDetails/EmployeeInsertExcel'
 
// const EmployeeDetails = () => {
//   return (
//     // <div style={{ display: 'flex' }}>
//     <div className="d-flex vh-100 bg-light">
//     <Sidebar />
//     {/* <Sidebar style={{ flex: '0 0 250px', minWidth: '250px' }} /> */}

//       <div style={{ flex: 1, padding: '20px' }}>
      
//         <Routes>
//           <Route path="add" element={<EmployeeFormContainer />} />
//           <Route path="list" element={<EmployeeList />} />
//           <Route path="edit/:id" element={<EmployeeFormContainer />} />
//           <Route path="attendance/add-excel" element={<AddAttendance />} />
//           <Route path="salary/process" element={<SalaryProcess />} />
//           <Route path="allowances" element={<Allowance />} />
//           <Route path="deductions" element={<Deduction />} />
//           {/* <Route path="salary-register" element={<SalaryRegister />} /> */}
//           <Route path="salary-reports" element={<SalaryReportsPage />} />
//           <Route path="bulkinsert" element={<EmployeeBulkInsert />} />
//         </Routes>
//       </div>
//     </div>
//   );
// };

// export default EmployeeDetails;


